export const daysRemaining = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const currentDate = new Date();

  const timeDifference = endDate - currentDate;
  const daysRemaining = Math.floor(timeDifference / (1000 * 60 * 60 * 24)) + 1;
  return daysRemaining;
};
